/**
 * 报表中心共用的格式化与 echarts option 构造方法
 *
 * 报表页统一走这里的配色和坐标轴样式，避免 8 个页面各写一套。
 */

export const REPORT_PALETTE = [
    "#1677ff", "#13b8b8", "#52c41a", "#faad14",
    "#7a5af8", "#eb2f96", "#fa8c16", "#c3ccd9",
];

export const FUNNEL_COLORS = [
    "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001f5c",
];

/** 金额，默认两位小数 */
export function money(value, digits = 2) {
    if (value === null || value === undefined || value === "") {
        return "0.00";
    }
    return Number(value).toLocaleString("zh-CN", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    });
}

/** 数量，带千分位 */
export function num(value, digits = 0) {
    const n = Number(value);
    if (isNaN(n)) {
        return "0";
    }
    return n.toLocaleString("zh-CN", {maximumFractionDigits: digits});
}

/** 百分比 */
export function pct(value, digits = 2) {
    const n = Number(value);
    return isNaN(n) ? "0.00%" : n.toFixed(digits) + "%";
}

/** 去掉空值，后端 GET 查询用 */
export function cleanParams(params) {
    const result = {};
    Object.keys(params || {}).forEach(key => {
        const value = params[key];
        if (value === "" || value === null || value === undefined) {
            return;
        }
        result[key] = value;
    });
    return result;
}

/** 环形图 */
export function donutOption(rows, centerValue, centerLabel) {
    return {
        tooltip: {trigger: "item", appendToBody: true, formatter: "{b}：{c} ({d}%)"},
        title: {
            text: String(centerValue === null || centerValue === undefined ? 0 : centerValue),
            subtext: centerLabel,
            left: "center",
            top: "center",
            textStyle: {fontSize: 20, fontWeight: 600, color: "#1f2329"},
            subtextStyle: {fontSize: 11, color: "#8d97a6"},
        },
        series: [{
            type: "pie",
            radius: ["58%", "80%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {show: false},
            labelLine: {show: false},
            itemStyle: {borderColor: "#fff", borderWidth: 2},
            data: (rows || []).map(row => ({
                name: row.name,
                value: row.value,
                itemStyle: {color: row.color},
            })),
        }],
    };
}

/** 横向条形图（类目多时只取前 limit 项） */
export function hBarOption(rows, color = "#1677ff", limit = 10) {
    const top = (rows || []).slice(0, limit).slice().reverse();
    return {
        tooltip: {trigger: "axis", appendToBody: true, axisPointer: {type: "shadow"}},
        grid: {left: "0", right: "40", bottom: "3%", top: "3%", containLabel: true},
        xAxis: {type: "value", minInterval: 1, splitLine: {lineStyle: {color: "#eee"}}, axisLabel: {color: "#909399"}},
        yAxis: {
            type: "category",
            data: top.map(row => row.name),
            axisTick: {show: false},
            axisLabel: {color: "#909399"},
        },
        series: [{
            type: "bar",
            barWidth: "50%",
            itemStyle: {color, borderRadius: [0, 3, 3, 0]},
            label: {show: true, position: "right", color: "#606266", fontSize: 11},
            data: top.map(row => row.value),
        }],
    };
}

/** 折线图 */
export function lineOption(names, data, color = "#1677ff") {
    return {
        tooltip: {trigger: "axis", appendToBody: true},
        grid: {left: "0", right: "8", bottom: "3%", top: "10%", containLabel: true},
        xAxis: {type: "category", boundaryGap: false, data: names || [], axisLabel: {color: "#909399"}},
        yAxis: {type: "value", splitLine: {lineStyle: {color: "#eee"}}, axisLabel: {color: "#909399"}},
        series: [{
            type: "line",
            smooth: true,
            itemStyle: {color},
            areaStyle: {opacity: 0.08, color},
            data: data || [],
        }],
    };
}

/** 竖向柱图 */
export function barOption(names, data, color = "#1677ff") {
    return {
        tooltip: {trigger: "axis", appendToBody: true, axisPointer: {type: "shadow"}},
        grid: {left: "0", right: "8", bottom: "3%", top: "10%", containLabel: true},
        xAxis: {type: "category", data: names || [], axisTick: {alignWithLabel: true}, axisLabel: {color: "#909399", interval: 0}},
        yAxis: {type: "value", splitLine: {lineStyle: {color: "#eee"}}, axisLabel: {color: "#909399"}},
        series: [{type: "bar", barWidth: "42%", itemStyle: {color}, data: data || []}],
    };
}

/** 漏斗图 */
export function funnelOption(rows) {
    return {
        tooltip: {trigger: "item", appendToBody: true, formatter: "{b}：{c}"},
        color: FUNNEL_COLORS,
        series: [{
            type: "funnel",
            left: "10%",
            right: "10%",
            top: 10,
            bottom: 10,
            minSize: "20%",
            label: {show: true, position: "inside", formatter: "{b}"},
            data: (rows || []).map(row => ({name: row.name, value: row.value})),
        }],
    };
}
